import {Component, EventEmitter, OnInit, Output} from "@angular/core";

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  @Output()
  private onPasswordChange: EventEmitter<string>;
  password: string;
  passwordCheckbox: any;

  inputType = "password";

  constructor() {
    this.onPasswordChange = new EventEmitter();
    this.password = "";
  }

  emitPassword(value) {
    this.password = value;
    this.onPasswordChange.emit(value);
  }

  ngOnInit() {
  }

  hideShowPassword() {
    if (this.inputType == 'password') {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/password/password.component.ts